export const SAVE_COMMENT = 'action/SAVE_COMMENT';
export const FETCH_COMMENTS = 'action/FETCH_COMMENTS';
